"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getAllCountries: ()=>getAllCountries,
    allCountriesByCode: ()=>buildCountryDropdown_allCountriesByCode,
    buildCountryDropdown: ()=>buildCountryDropdown,
    uniqCountryCodes: ()=>uniqCountryCodes
});
const external_countryLists_js_namespaceObject = require("./countryLists.js");
const getAllCountries = ()=>external_countryLists_js_namespaceObject.allCountriesNewList;
const buildCountryDropdown_allCountriesByCode = getAllCountries().reduce((allCountriesByCode, country)=>{
    allCountriesByCode[country.code] = country;
    return allCountriesByCode;
}, {});
function buildCountryDropdown() {
    const allCountriesHashmap = {};
    const allCountriesList = [];
    getAllCountries().forEach((country)=>{
        if (allCountriesHashmap[country.phoneCode]) {
            if ('us' === country.code) allCountriesHashmap[country.phoneCode].names.unshift(country.name);
            else if ('pr' !== country.code) allCountriesHashmap[country.phoneCode].names.push(country.name);
        } else allCountriesHashmap[country.phoneCode] = {
            names: [
                country.name
            ],
            phoneCode: country.phoneCode
        };
    });
    for(const keyNumber in allCountriesHashmap)if (Object.prototype.hasOwnProperty.call(allCountriesHashmap, keyNumber)) {
        const number = {
            ...allCountriesHashmap[keyNumber]
        };
        number.names = `+${keyNumber} ${number.names.join(' and ')}`;
        allCountriesList.push(number);
    }
    return allCountriesList;
}
const uniqCountryCodes = buildCountryDropdown().map((country)=>({
        phoneCode: parseInt(country.phoneCode),
        label: country.names
    }));
exports.allCountriesByCode = __webpack_exports__.allCountriesByCode;
exports.buildCountryDropdown = __webpack_exports__.buildCountryDropdown;
exports.getAllCountries = __webpack_exports__.getAllCountries;
exports.uniqCountryCodes = __webpack_exports__.uniqCountryCodes;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "allCountriesByCode",
    "buildCountryDropdown",
    "getAllCountries",
    "uniqCountryCodes"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
